import React from 'react';
import AdminSidebarRow from './AdminSidebarRow';
import './AdminFilterList.css';

/**
 * @param {{
 *   items?: Array<{
 *     id: string,
 *     label: React.ReactNode,
 *     count?: number | string | null,
 *     dotColor?: string | null
 *   }>,
 *   selectedIds?: string[],
 *   onToggle?: ((id: string, nextChecked: boolean) => void) | null,
 *   name?: string
 * }} props
 */
function AdminFilterList({
  items = [],
  selectedIds = [],
  onToggle = null,
  name = 'admin-filter-list',
}) {
  const selectedSet = new Set(selectedIds);

  return (
    <div className="au-filter-list au-scope" role="group" aria-label={name}>
      {items.map((item) => {
        const checked = selectedSet.has(item.id);

        return (
          <AdminSidebarRow
            key={item.id}
            active={checked}
            count={item.count}
            dotColor={item.dotColor}
            onClick={onToggle ? () => onToggle(item.id, !checked) : undefined}
          >
            <span className="au-filter-list__label">
              <span className={`au-filter-list__checkbox${checked ? ' is-checked' : ''}`} aria-hidden="true" />
              <span>{item.label}</span>
            </span>
          </AdminSidebarRow>
        );
      })}
    </div>
  );
}

export default AdminFilterList;
